export default "__VITE_PUBLIC_ASSET__e87a85f3__"